/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import placeholderFR from "../../assets/candidate.png";
import placeholderDE from "../../assets/kandidate.png";

const PartyLogo = ({ imageUrl, imageUrlFallback, party, langId }) => {
  const [imgUrl, setImgUrl] = useState("");

  useEffect(() => {
    // Fetch the image and check if it exists
    fetch(imageUrl)
      .then((res) => {
        if (res.status === 200) {
          setImgUrl(imageUrl);
        } else {
          setImgUrl(langId === "de" ? placeholderDE : placeholderFR);
        }
      })
      .catch(() => {
        setImgUrl(langId === "de" ? placeholderDE : placeholderFR);
      });
  }, [imageUrl]);

  return (
    <picture>
      <source
        srcSet={imgUrl}
        type="image/webp"
        onError={() => {
          setImgUrl(imageUrlFallback);
        }}
      />
      <img
        src={imgUrl}
        alt=""
        onError={() => {
          setImgUrl(langId === "de" ? placeholderDE : placeholderFR);
        }}
        width={party === "csv" ? "39px" : "29px"}
        height="29px"
      />
    </picture>
  );
};

export default PartyLogo;
